import { createBrowserClient } from '@supabase/ssr';

export const createClient = () =>
  createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL as any,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY as any,
  );
